import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

import CoreFormattedLink from '@stubhub/react-formatted-link-core';

const FormattedLink = ({LinkComp, ...props}, {globalRegistry, matchRoutes = () => true}) => {
  const defaultLocale = globalRegistry && globalRegistry.getDefaultLocale();
  const currentLocale = globalRegistry && globalRegistry.getCurrentLocale();

  return (
    <CoreFormattedLink
      {...props}
      defaultLocale={defaultLocale}
      currentLocale={currentLocale}
      matchRoutes={matchRoutes}
      LinkComp={LinkComp || Link}
    />
  );
};

FormattedLink.propTypes = {
  /** Children node */
  children: PropTypes.node,

  /** Is this a external link? */
  externalLink: PropTypes.bool,

  /** Href for the link */
  href: PropTypes.string,

  /** Link component to use if it's not an external link. Will default to react-router-dom Link*/
  LinkComp: PropTypes.elementType,

  /** Ref to assign to the link */
  linkRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({current: PropTypes.any})]),

  /** Custom locale */
  locale: PropTypes.string,
};

FormattedLink.contextTypes = {
  globalRegistry: PropTypes.object,
  matchRoutes: PropTypes.func,
};

export default FormattedLink;
